import { ArrowsRightLeftIcon, PencilIcon } from '@heroicons/react/24/outline'
import { useMemo } from 'react'

import { SparklesIcon } from '@heroicons/react/24/solid'
import { useTranslation } from 'react-i18next'
import useChartContext from '../Dashboard/charts/useChartContext'

import { Widget } from '../types'
import { Card } from './Card'

export const SectionWidget = ({ widget }: { widget: Widget }) => {
  const { t } = useTranslation()
  const { selectedCompareOption } = useChartContext()
  const isCompareEnabled = useMemo(
    () => selectedCompareOption.id !== '',
    [selectedCompareOption]
  )
  return (
    <section key={widget.id} className="py-4 group/widget">
      <div className="relative">
        {widget.supportsComparisons && isCompareEnabled && (
          <div className="absolute right-3 -top-4 border bg-indigo-600 text-white py-2 px-3 rounded-full text-xs font-medium z-10 flex items-center space-x-3">
            <ArrowsRightLeftIcon className="h-4" />
            <span>{t('comparison')}</span>
          </div>
        )}

        {widget.isCustom && (
          <div className="absolute left-3 -top-4 border border-indigo-500 text-indigo-700 bg-white py-2 px-3 rounded-lg text-xs font-medium z-10 flex items-center gap-2 shadow-sm">
            <span>{t('custom_widgets.custom_widget')}</span>
            <SparklesIcon className="h-3" />
          </div>
        )}

        {widget.isCustom && (
          <div className="absolute left-3 -top-4 border bg-gray-200 text-black py-2 px-3 rounded-full text-xs font-medium z-10 flex items-center gap-2.5">
            <PencilIcon className="h-3.5" />
            <span>Custom</span>
          </div>
        )}

        <Card
          className={`overflow-hidden ${
            widget.supportsComparisons && isCompareEnabled
              ? '!border-indigo-600'
              : ''
          }`}
        >
          {widget.chart}
        </Card>
      </div>
    </section>
  )
}
